// extracted by mini-css-extract-plugin
export default {"modalHead":"styles_modalHead__IZ3gk","content":"styles_content__OvozM","text":"styles_text__eoibH","controls":"styles_controls__rnycI","button":"styles_button__UowAN"};